module.exports = __webpack_public_path__ + "img/cspr.527954e4.svg";